import React from "react";
import filter from "../../assets/images/filter.svg";
import blueFilter from "../../assets/images/BlueFilterIcon.svg";

const ArtworkStatusProjectNameHeader = (
  options,
  frozenCoulmns,
  sortData,
  projectNameOnClick,
  selectedFields
) => {
  let splittedCol = options?.split("_").join(" ");
  const isFrozen = frozenCoulmns?.includes(options);

  return (
    <div className={`flex-display ${isFrozen ? "font-bold frozen-width" : ""}`}>
      <>
        <img
          src={selectedFields?.[options]?.[0] ? blueFilter : filter}
          alt="Column Filter"
          onClick={(e) => projectNameOnClick(e, options)}
          className="columnFilterIcon"
        />
        <span className="columnFilterIcon">
          {splittedCol === "PIMaterialNumber" && "PIMaterialNumber"}
          {splittedCol === "CountryOfSales" && "Country Of Sales"}
          {splittedCol === "FAAssemblyState" && "Assemble FA Status"}
          {splittedCol === "FAAssemblyEndDate" && "Assemble FA End Date"}
          {splittedCol === "FAApprovalEndDate" && "Approve FA End Date"}
          {splittedCol === "FAApproval" && "FA Approval (A/A/R)"}
          {splittedCol === "PIMaterialID" && "PIMaterialID"}
          {splittedCol === "PIMaterialDescription" && "PIMaterialDescription"}
          {splittedCol === "POANumber" && "POA Number"}
          {splittedCol === "POADescription" && "POA Description"}
          {splittedCol === "BufferToWorkRatio" && "B:W"}
          {splittedCol === "BufferToWork" && "B|W"}
          {splittedCol === "ETA" && "ETA (AWM)"}
          {splittedCol === "Req" && "AW Date (DSBP)"}
          {splittedCol === "AWM GroupPMP" && "Group"}
          {splittedCol === "AWM CICNeeded" && "CIC"}
          {splittedCol === "ApprovedCopyElements" && "Copy"}
          {/* FA */}
          {splittedCol === "POAStatus" && "POA Status"}
          {splittedCol === "TDState" && "TD State"}
          {splittedCol === "PMPState" && "PMP State"}
          {splittedCol === "RTA RTAPOAStatus" && "POA Status"}
          {splittedCol === "ProjectID" && "Project ID"}
          {splittedCol === "CICApprovalStatus" && "CIC Approval Status"}
          {splittedCol === "Rework" && "Rework"}
          {splittedCol === "SupportingPMP" && "Supporting PMP"}
          {splittedCol === "CICNeededFlag" && "CIC Needed Flag"}
          {splittedCol === "RDTStatus" && "RDT"}
          {splittedCol === "NPFStatus" && "CD/PT"}
          {splittedCol === "IQStatus" && "Ink Qual"}
          {splittedCol === "Estimated AW Printer" && "No Miss AW@Printer date"}
          {splittedCol === "POATOBVEStatus" && "Send POA to BVE Status"}
          {splittedCol === "POATOBVEEndDate" && "Send POA to BVE End Date"}
          {splittedCol === "DispatchFAToPrinterStatus" && "Color Sep. Status"}
          {splittedCol === "DispatchFAToPrinterEndDate" && "Color Sep. End Date"}
          {splittedCol === "AWM PMPStatusComment" && "PMP Status Comment"}

          {splittedCol !== "PIMaterialNumber" &&
            splittedCol !== "PIMaterialID" &&
            splittedCol !== "PIMaterialDescription" &&
            splittedCol !== "POANumber" &&
            splittedCol !== "POADescription" &&
            splittedCol !== "BufferToWorkRatio" &&
            splittedCol !== "BufferToWork" &&
            splittedCol !== "POAReleaseDate" &&
            splittedCol !== "AWPrinterDate" &&
            splittedCol !== "AWM GroupPMP" &&
            splittedCol !== "AWM CICNeeded" &&
            splittedCol !== "CountryOfSales" &&
            splittedCol !== "FAAssemblyState" &&
            splittedCol !== "FAAssemblyEndDate" &&
            splittedCol !== "FAApprovalEndDate" &&
            splittedCol !== "FAApproval" &&
            splittedCol !== "ApprovedCopyElements" &&
            splittedCol !== "POAStatus" &&
            splittedCol !== "TDState" &&
            splittedCol !== "PMPState" &&
            splittedCol !=="RTA RTAPOAStatus"&&
            splittedCol !== "ProjectID" &&
            splittedCol !== "CICApprovalStatus" &&
            splittedCol !== "Rework" &&
            splittedCol !== "SupportingPMP" &&
            splittedCol !== "CICNeededFlag" &&
            splittedCol !== "RDTStatus" &&
            splittedCol !== "NPFStatus" &&
            splittedCol !== "IQStatus" &&
            splittedCol !== "ETA" &&
            splittedCol !== "Req" &&
            splittedCol !== "Estimated AW Printer" &&
            splittedCol !== "POATOBVEStatus" &&
            splittedCol !== "POATOBVEEndDate" &&
            splittedCol !== "DispatchFAToPrinterStatus" &&
            splittedCol !== "DispatchFAToPrinterEndDate" &&
            splittedCol !== "AWM PMPStatusComment" &&
            splittedCol}
        </span>
      </>
    </div>
  );
};

export default ArtworkStatusProjectNameHeader;
